<template>
    <div class="region-selector-block">
        <div class="region-selector-content w-100">
            <div class="form-group m-0">
                <span class="error-input-container dropdown-with-info-container" v-if="regions">
                    <button class="dropdown-with-info-container--toggle" v-if="selectedRegion">
                        <span>{{ selectedRegion.name }}</span>
                    </button>

                    <select class="form-control" v-model="selectedRegionIso" @change="changeRegion">
                        <option :value="region.iso" v-for="(region) in regions">{{ region.name }}</option>
                    </select>
                </span>
            </div>
        </div>
    </div>
</template>

<script>

import cookiesEnum from "@/core/constants/cookiesEnum";
import {removeCookie, setCookie} from "@/core/utils/helpers/cookieHelper";
import {regionIsoEnum} from "@/core/enums/regionIsoEnum";
import {getRegionPathConfig} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        store: $store,
        selectedRegionIso: regionIsoEnum.GERMANY,
    }
}

function created() {
    if (this.envRegionIso) {
        const selectedRegionInCookies = this.regions.find(r => r.iso === this.envRegionIso);

        if (selectedRegionInCookies) {
            this.selectedRegionIso = this.envRegionIso;
        }
    }
}

function changeRegion() {
    setCookie(cookiesEnum.REDIRECT_TO_REGION, this.selectedRegionIso);
    window.location.href = '/';
}

export default {
    data,
    created,
    computed: {
        ...mapState(['translate']),
        regions() {
            return [
                {name: _.get(this, 'translate.home.austria'), iso: regionIsoEnum.AUSTRIA},
                {name: _.get(this,'translate.home.australia'), iso: regionIsoEnum.AUSTRALIA},
                {name: _.get(this, 'translate.home.brazil'), iso: regionIsoEnum.BRAZIL},
                {name: _.get(this, 'translate.home.germany'), iso: regionIsoEnum.GERMANY},
                {name: _.get(this, 'translate.home.unitedKingdom'), iso: regionIsoEnum.UNITED_KINGDOM},
                {name: _.get(this, 'translate.home.italy'), iso: regionIsoEnum.ITALY},
            ];
        },
        selectedRegion() {
            return this.regions.find(r => r.iso === this.selectedRegionIso)
        },
        envRegionIso() {
            return getRegionPathConfig();
        }
    },
    methods: {
        changeRegion,
    },
}
</script>
